import classNames from 'classnames';

type Props = {
    extraClasses?: string;
};
export default function GridNeo({ children, extraClasses = '' }: React.PropsWithChildren<Props>) {
    return (
        <div className="mx-auto w-full h-full px-4 md:px-6 lg:px-0">
            <div
                className={classNames(
                    'grid',
                    'grid-cols-4 md:grid-cols-8 lg:grid-cols-12',
                    'gap-x-4 md:gap-x-6',
                    'h-full lg:max-w-screen-xl mx-auto',
                    'items-stretch',
                    extraClasses
                )}
            >
                {children}
            </div>
        </div>
    );
}
